import { accommodationTypeIdZodSchema } from "@@/shared/acquire/resources/resource-accommodation/accommodation-types/accommodation-type-id";
import { resourceFoundationIdZodSchema } from "@@/shared/acquire/resources/resource-foundation-id";
import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { idZodSchema } from "@@/shared/id";
import { providerIdZodSchema } from "@@/shared/providers/provider-id";
import { requiredTranslatableZodSchema } from "@@/shared/translations/translation";
import { generateId } from "@@/utilities/generate-id";
import { z } from "zod";

const resourceAccommodationAddCommandZodObject = z.object({
    _id: idZodSchema,
    _type: z.literal("RESOURCE_ACCOMMODATION_ADD_COMMAND"),
    _createdAt: isoAndUnixZodSchema,
    accommodationTypeId: accommodationTypeIdZodSchema,
    // resourceId: resourceIdZodSchema,
    providerId: providerIdZodSchema,
    title: requiredTranslatableZodSchema,
    quantityToCreate: z.number().int().min(1),
    /** If foundationId is provided, the resources will be added to the
     * foundation if the foundations is of the correct resource type.
     */
    foundationId: resourceFoundationIdZodSchema.optional(),
    /** If creating multiple at the same time index added to resource
     * names starts given start index, or defaults to `1` */
    startAtIndex: z.number().int().min(0).optional(),
    customIndexes: z.array(z.number().int().min(0)).optional(),
});
type ResourceAccommodationAddCommand = z.infer<
    typeof resourceAccommodationAddCommandZodObject
>;

const resourceAccommodationAddCommandFactoryParamsZodObject =
    resourceAccommodationAddCommandZodObject.omit({
        _id: true,
        _type: true,
        _createdAt: true,
    });
type FactoryParams = z.infer<
    typeof resourceAccommodationAddCommandFactoryParamsZodObject
>;

const resourceAccommodationAddCommandFactory = (params: FactoryParams) => {
    const resourceAccommodationAddCommand: ResourceAccommodationAddCommand = {
        ...params,
        _id: generateId({ prefix: "resource_accommodation_add_command__" }),
        _type: "RESOURCE_ACCOMMODATION_ADD_COMMAND",
        _createdAt: nowIsoAndUnix(),
    };
    return resourceAccommodationAddCommand;
};

export {
    resourceAccommodationAddCommandFactory,
    resourceAccommodationAddCommandFactoryParamsZodObject,
    resourceAccommodationAddCommandZodObject,
};
export type {
    ResourceAccommodationAddCommand,
    FactoryParams as ResourceAccommodationAddCommandFactoryParams,
};
